import { ChevronUp, MoreVertical } from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
  getStatusIconAndColor,
  MESSAGES,
  TASK_STATUS,
  TASK_STATUS_LABELS,
} from "../Constants";
import { TASK_DETAILS } from "../../../routes";
import { useState } from "react";

const TaskListCard = ({ tasks = [], isSubtask = false }) => {
  const navigate = useNavigate();
  const [selectedTask, setSelectedTask] = useState(null);
  return (
    <ul className="border-l-2 pl-7 md:pl-8 space-y-2 w-full">
      {tasks?.map((m, index) => {
        const { icon, color } = getStatusIconAndColor(m.status);
        return (
          <div className="relative group rounded-lg w-full" key={index}>
            <span
              className={`absolute text-sm md:text-md -left-12 -md:left-16 top-1 ${color} rounded-full py-1 px-3 border-4 border-white`}
            >
              {index + 1}
            </span>
            <div className="relative flex border mb-2 py-2 px-1 rounded-md w-full">
              <div className=" flex-shrink-0 flex justify-center">
                <button
                  className={`${isSubtask ? "hidden " : ""} ${
                    m?.sub_tasks?.length > 0
                      ? ""
                      : "cursor-not-allowed opacity-50"
                  }`}
                  disabled={m?.sub_tasks?.length > 0 ? false : true}
                >
                  <ChevronUp
                    className={`${
                      selectedTask === m.id ? "rotate-180" : "rotate-90"
                    } transform transition-transform duration-300 cursor-pointer`}
                    onClick={() =>
                      selectedTask
                        ? setSelectedTask(null)
                        : setSelectedTask(m.id)
                    }
                    size={28}
                  />
                </button>
              </div>
              <div
                className="w-full px-1 cursor-pointer"
                onClick={() => {
                  navigate(TASK_DETAILS.replace(":instanceId", m.id));
                }}
              >
                <div className="grid grid-cols-6 items-end md:items-center w-full relative">
                  <div className="col-span-3">
                    <div className="flex justify-between items-center mb-1 text-sm">
                      <h3 className="font-semibold text-gray-800 truncate">
                        {m.title}
                      </h3>
                    </div>
                    <p className="text-sm text-gray-500 max-w-[70%] truncate">
                      {m.description}
                    </p>
                  </div>
                  <div className="flex justify-center md:justify-self-center md:col-span-1 col-span-2">
                    <p
                      className={`text-[9px] ${color} rounded-full py-1 px-2 border-4 border-white w-max`}
                    >
                      {TASK_STATUS_LABELS[m.status]}
                    </p>
                  </div>
                  <div className="hidden md:block col-span-1">
                    {m?.assigned_to ? (
                      <div className="flex justify-end gap-2">
                        <span className="text-sm">
                          {m.assigned_to.first_name} {m.assigned_to.last_name}
                        </span>
                      </div>
                    ) : (
                      <p className="flex justify-end text-gray-400 text-sm italic">
                        {MESSAGES.NOT_ASSIGNED_YET}
                      </p>
                    )}
                  </div>
                  <div className="flex justify-end items-center gap-1 md:gap-6 col-span-1 pr-2">
                    <strong
                      className={`${
                        m.status === TASK_STATUS.CLOSED ? "text-green-400" : ""
                      }`}
                    >
                      {m.weight}
                    </strong>
                  </div>
                </div>
                <div className="md:hidden flex justify-end w-max">
                  {m?.assigned_to ? (
                    <div className="flex items-center gap-2">
                      <span className="text-sm">
                        Assigned To {m.assigned_to.first_name} {m.assigned_to.last_name}
                      </span>
                    </div>
                  ) : (
                    <p className="text-gray-400 text-sm italic">
                      {MESSAGES.NOT_ASSIGNED_YET}
                    </p>
                  )}
                </div>
              </div>
            </div>
            {selectedTask === m.id && (
              <div className="">
                {m?.sub_tasks?.length > 0 ? (
                  <TaskListCard tasks={m.sub_tasks} isSubtask={true} />
                ) : (
                  <p className="text-sm text-gray-400 italic">No sub-tasks</p>
                )}
              </div>
            )}
          </div>
        );
      })}
    </ul>
  );
};

export default TaskListCard;
